import url from '../../../../url.js';
export default {
    name: "Technology",
    data() {
        return {
            title: 'Technology',
            dataTeknologi: [],
            ApiUrl: url.API_URL,
        }
    },
    methods: {
        async fetchData() {
            const response = await fetch(this.ApiUrl + 'm146_technologies/id/2');
            const data = await response.json();
            this.dataTeknologi = data;
        }
    },
    mounted(){
        this.fetchData();
    }
}